

import React from 'react';
// import { FormGroup, Input, FormFeedback, Label} from 'reactstrap'
import {connect} from 'react-redux'; 
import StringInput from "../StringInput"
import * as actions from "store/actions/colors"
import validation from '../../validation';
import * as yup from 'yup';
import ActiveField from 'components/Forms/ActiveField'

class ActiveCheckbox extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            name: "active",
            invalid: false
        }
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
   
    }

    handleChange(event){
        this.props.actions.change(this.state.name, !this.props.active)
    }

    
    render(){
        return(
           <ActiveField
                handleAction={this.handleChange}
                value={this.props.active}></ActiveField>
        )
    }
}
const mapStateToProps = (state) => {
    return {
         active: state.colors.color.active,
         error: state.colors.errors.active
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions:{
            setError: (name, value) => {
                return dispatch({
                    type: actions.SET_ERROR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            },
            change: (name, value) => {
                return dispatch({
                    type: actions.CHANGE_ATTR,
                    payload: {
                        name: name,
                        value: value
                    }
                })
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveCheckbox);